import { __awaiter, __generator } from "tslib";
import { handleDirectPurchase } from './handleDirectPurchase';
import { SPECS } from '../../../constants';
import { PageMap } from '@wix/wixstores-client-core';
export var createCheckoutExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    return ({
        handleDirectPurchase: handleDirectPurchase({ context: context, origin: origin }),
        preloadCheckoutPage: function () { return __awaiter(void 0, void 0, void 0, function () {
            var sectionUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!context.siteStore.experiments.enabled(SPECS.ShouldPreloadEcomPagesAndLightboxes)) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, context.siteStore.getSectionUrl(PageMap.CHECKOUT)];
                    case 2:
                        sectionUrl = _a.sent();
                        if (sectionUrl.relativeUrl) {
                            context.siteStore.siteApis.prefetchPageResources({ pages: [sectionUrl.relativeUrl] });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error('failed to prefetch checkout page', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
    });
};
//# sourceMappingURL=wixcode.checkout.js.map